import type { NextPage } from 'next';
import { useRouter } from 'next/router';

import { Box, Container } from '@chakra-ui/react';

import { FooterNav } from '~/components/footer-nav';
import { PageLayout } from '~/components/page-layout';
import { ResetPasswordForm } from '~/features/reset-password';
import { NewPasswordForm } from '~/features/reset-password/new-password-form';

const ResetPassword: NextPage = () => {
  const router = useRouter();

  const accessToken = router.query.accessToken;

  return (
    <PageLayout>
      <Container maxW='4xl' py={{ base: 4, lg: 16 }}>
        {accessToken ? <NewPasswordForm accessToken={accessToken as string} /> : <ResetPasswordForm />}
        <Box h={8} />
        <FooterNav colorScheme='medium-gray' />
      </Container>
    </PageLayout>
  );
};

export default ResetPassword;
